import request from '@/utils/server'
// 新增
  export function addStorageLocation(data) {
    return request({
      url: '/inventory/addStorageLocation',
      method: 'POST',
      data:data
    })
  }
//  请求列表
export function getStorageLocation(query) {
  return request({
    url: '/inventory/getStorageLocation',
    method: 'get',
    params: query
  })
}
// 删除
export function deleteStorageLocation(data) {
    return request({
      url: '/inventory/deleteStorageLocation',
    method: 'POST',
      data:data
    })
  }
//   修改
export function updateStorageLocation(data) {
    return request({
      url: '/inventory/updateStorageLocation',
      method: 'POST',
      data:data
    })
  }
// 获取所有仓库列表
export function getAllHouse(query) {
  return request({
    url: '/inventory/getAllHouse',
    method: 'get',
    params: query
  })
}